import type { GetCustomersNamesResponse } from '@vy/api-definition';
import { GetCustomersNamesResponseSchema } from '@vy/api-definition';
import type { PaginationInput } from '@vy/types';
import { ALL_ITEMS_PAGE_SIZE_CODE } from '@vy/types';
import { validateNotEmptyObject } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useAllCustomersNames(options?: CustomUseQueryOptions<GetCustomersNamesResponse>) {
  const allCustomersQuery = useCustomersNames({
    ...options,
    page: 0,
    pageSize: ALL_ITEMS_PAGE_SIZE_CODE,
  });

  return allCustomersQuery;
}

function useCustomersNames({
  page,
  pageSize,
  ...options
}: PaginationInput & CustomUseQueryOptions<GetCustomersNamesResponse>) {
  const customersNamesQuery = useQuery(
    queryKeys.customersNames(page, pageSize),
    async () => {
      const privateApi = getPrivateApi();
      const getCustomersNamesResponse = await privateApi.getCustomersNames({
        page,
        pageSize,
      });

      return GetCustomersNamesResponseSchema.parse(getCustomersNamesResponse);
    },
    { suspense: true, ...options },
  );

  validateNotEmptyObject(customersNamesQuery.data, 'CustomersNames');

  return customersNamesQuery;
}
